import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import getConfiguredLineItemQueryDocument from "./getConfiguredLineItemQuery.graphql";
import type {
  ConfigurationLineItemTypeExtension,
  ConfigurationSectionInputTl,
  InputCreateConfiguredLineItemCommandTl,
} from "../../../types";

export async function getConfiguredLineItem(
  configurableProductId: string,
  quantity: number,
  configurationSections: ConfigurationSectionInputTl[],
): Promise<ConfigurationLineItemTypeExtension> {
  const { storeId, cultureName, currencyCode } = globals;
  const { data } = await graphqlClient.mutate<
    GetConfiguredLineItem,
    { command: InputCreateConfiguredLineItemCommandTl }
  >({
    mutation: getConfiguredLineItemQueryDocument,
    variables: {
      command: {
        storeId: storeId,
        cultureName: cultureName,
        currencyCode: currencyCode,
        quantity: quantity,
        configurableProductId: configurableProductId,
        configurationSectionsTL: configurationSections,
      },
    },
  });
  return data!.createConfiguredLineItemTL;
}

export interface GetConfiguredLineItem {
  createConfiguredLineItemTL: ConfigurationLineItemTypeExtension;
}
